import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const RockingChair = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 23C28 22.45 27.55 22 27 22C26.762 22 26.55 22.075 26.387 22.212C26.387 22.212 25.3 23.075 23.599 23.95L20.611 18H22.998C23.548 18 23.998 17.55 23.998 17C23.998 16.45 23.548 16 22.998 16H19.998V12H22.998C23.548 12 23.998 11.55 23.998 11C23.998 10.45 23.548 10 22.998 10H11.723L9.948 4.675C9.811 4.287 9.436 4 8.998 4C8.448 4 7.998 4.45 7.998 5C7.998 5.112 8.01 5.213 8.048 5.313L11.923 16.926L8.411 23.951C6.711 23.076 5.624 22.213 5.624 22.213C5.449 22.076 5.236 22.001 5.012 22.001C4.462 22.001 4.012 22.451 4.012 23.001C4.012 23.314 4.162 23.601 4.387 23.776C4.387 23.776 9.637 28.001 16.012 28.001C22.287 28.001 27.637 23.776 27.637 23.776C27.849 23.601 28 23.314 28 23.001V23ZM18 12V16H13.725L12.387 12H18ZM16 26C13.887 26 11.887 25.462 10.225 24.788L13.625 18H18.387L21.787 24.788C20.112 25.463 18.112 26 16 26Z" />
	</svg>
);

export default RockingChair;
